import React, { Component } from "react";
import Button from "../../../button-classic/button-classic";
import "./add-supplier-item-master.less";
import InputText from "../../../../common/components/input-text/input-text";
import Delete from "../../../../assets/images/delete.svg";
import ACTIONS from "../../../../common/action_constant";

class AddSupplierItemMaster extends Component {
  constructor(props) {
    super(props);

    const editData = props.editData;

    this.state = {
      previousData: editData ? JSON.parse(JSON.stringify(editData)) : null,
      data: {
        item_name: editData?.item_name || "",
        item_numbers:
          editData?.item_numbers?.length > 0 ? [...editData.item_numbers] : [""],
        process_points_details:
          editData?.process_points_details?.length > 0
            ? editData.process_points_details.map((pp) => ({
                id: pp.id || "",
                description: pp.description || "",
              }))
            : [{ id: "", description: "" }],
      },
    };
  }

  onChangeHandler = (value, field) => {
    this.setState((prevState) => ({
      data: {
        ...prevState.data,
        [field]: value,
      },
    }));
  };

  addItemNumberRow = () => {
    let { data } = this.state;
    data.item_numbers.push("");
    this.setState({ data });
  };

  removeItemNumberRow = (index) => {
    let { data } = this.state;
    const updated = [...data.item_numbers];
    updated.splice(index, 1);
    this.setState({ data: { ...data, item_numbers: updated } });
  };

  onChangeItemNumber = (index, value) => {
    let { data } = this.state;
    data.item_numbers[index] = value;
    this.setState({ data });
  };

  addProcessPointRow = () => {
    let { data } = this.state;
    data.process_points_details.push({ id: "", description: "" });
    this.setState({ data });
  };

  removeProcessPointRow = (index) => {
    let { data } = this.state;
    const updated = [...data.process_points_details];
    updated.splice(index, 1);
    this.setState({ data: { ...data, process_points_details: updated } });
  };

  onChangeProcessPoint = (index, value) => {
    let { data } = this.state;
    data.process_points_details[index].description = value;
    this.setState({ data });
  };

  onSave = () => {
    debugger
    const { data, previousData } = this.state;
    const { dispatch, editData, companyId, toggleAdd, refreshData } = this.props;

    const itemNumbers = data.item_numbers.map((n) => n.trim()).filter(Boolean);
    const processPoints = data.process_points_details
      .filter((pp) => pp.description.trim())
      .map((pp) => (pp.id ? { id: pp.id, description: pp.description.trim() } : { description: pp.description.trim() }));

    const basePayload = {
      company_id: companyId,
      item_name: data.item_name.trim(),
      item_numbers: itemNumbers,
      process_points_details: processPoints,
    };

    if (editData) {
      const payload = {
        ...basePayload,
        master_id: editData.master_id,
        created: editData.created,
        updated_on: editData.updated_on,
        previous_data: previousData,
      };

      dispatch({
        type: ACTIONS.PLANTS.UPDATE_SUPPLIER_ITEM_MASTER,
        data: payload,
        onSuccess: () => {
          toggleAdd();
          refreshData?.();
        },
      });
    } else {
      dispatch({
        type: ACTIONS.PLANTS.ADD_SUPPLIER_ITEM_MASTER,
        data: basePayload,
        onSuccess: () => {
          toggleAdd();
          refreshData?.();
        },
      });
    }
  };

  render() {
    const { data } = this.state;
    const { toggleAdd, editData } = this.props;

    const isValid =
      data.item_name.trim() &&
      data.item_numbers.some((n) => n.trim()) &&
      data.process_points_details.some((pp) => pp.description.trim());

    return (
      <div>
        <div className="supplier-item-modal-overlay" onClick={toggleAdd} />

        <div className="supplier-item-modal">
          <div className="supplier-item-modal-header">
            <div className="supplier-item-modal-title">
              {editData ? "Edit" : "Add"} Supplier Item Master
            </div>
            <div className="supplier-item-modal-close" onClick={toggleAdd}>
              &times;
            </div>
          </div>

          <div className="supplier-item-modal-body">
            <div className="supplier-item-field-group">
              <InputText
                label="Item Name"
                required
                id="item_name"
                placeholder="Enter item name"
                value={data.item_name}
                changeHandler={this.onChangeHandler}
              />
            </div>

            <div className="supplier-item-field-group">
              <div className="supplier-item-field-group-header">
                <div className="supplier-item-field-group-label">
                  Item Numbers <span className="error-color">*</span>
                </div>
                <button
                  type="button"
                  className="supplier-item-add-row-btn"
                  onClick={this.addItemNumberRow}
                >
                  + Add Item Number
                </button>
              </div>

              {data.item_numbers.map((itemNumber, index) => (
                <div className="supplier-item-dynamic-row" key={index}>
                  <div className="supplier-item-row-index">{index + 1}</div>
                  <input
                    type="text"
                    placeholder="Item number"
                    value={itemNumber}
                    onChange={(e) => this.onChangeItemNumber(index, e.target.value)}
                  />
                  <div
                    className="supplier-item-remove-row-btn"
                    onClick={() => this.removeItemNumberRow(index)}
                  >
                    <img src={Delete} alt="Remove" />
                  </div>
                </div>
              ))}
            </div>

            <div className="supplier-item-field-group">
              <div className="supplier-item-field-group-header">
                <div className="supplier-item-field-group-label">
                  Process Points <span className="error-color">*</span>
                </div>
                <button
                  type="button"
                  className="supplier-item-add-row-btn"
                  onClick={this.addProcessPointRow}
                >
                  + Add Process Point
                </button>
              </div>

              {data.process_points_details.map((pp, index) => (
                <div className="supplier-item-dynamic-row" key={index}>
                  <div className="supplier-item-row-index">{index + 1}</div>
                  <input
                    type="text"
                    placeholder="Process point description"
                    value={pp.description}
                    onChange={(e) => this.onChangeProcessPoint(index, e.target.value)}
                  />
                  <div
                    className="supplier-item-remove-row-btn"
                    onClick={() => this.removeProcessPointRow(index)}
                  >
                    <img src={Delete} alt="Remove" />
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="supplier-item-modal-footer">
            <Button value="Cancel" click={toggleAdd} />
            <Button
              value={editData ? "Update" : "Save"}
              disabled={!isValid}
              click={this.onSave}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default AddSupplierItemMaster;
